/*
 * @Author: Witt
 * @Date: 2018-10-29 10:26:58
 * @Last Modified by: Witt
 * @Last Modified time: 2018-10-29 15:49:12
 */
import { ControlValueConverter, DateUtil } from '@farris/devkit';

/**
 * æ¥æè½¬æ¢å¨
 */
class DateConverter implements ControlValueConverter {

  /**
   * æé å½æ°
   * @param format æ¥ææ ¼å¼
   */
  constructor(private format: string) {
  }

  /**
   * å­ç¬¦ä¸²=> æ¥æ
   * @param value å¾è½¬æ¢çå¼
   */
  convertFrom(value: string): Date {
    if (DateUtil.isEmptyDateString(value) === true) {
      return null;
    }

    return DateUtil.parse(value);
  }

  /**
   * æ¥æ=>å­ç¬¦ä¸²
   * @param value
   */
  convertTo(value: Date): string | any {
    if (!value) {
      return null;
    }
    // å¦ævalueä¸æ¯æ¥æç±»åï¼åä¸åå¤çï¼è¿ååå§value
    if (Object.prototype.toString.call(value) !== '[object Date]') {
      return value;
    }
    // å¹´
    let year = value.getFullYear().toString();
    year = year.length < 4 ? '0'.repeat(4 - year.length) + year : year;
    // æ
    let month = (value.getMonth() + 1).toString();
    month = month.length === 1 ? ('0' + month) : month;

    // æ¥
    let day = value.getDate().toString();
    day = day.length === 1 ? ('0' + day) : day;

    // æ¶åç§
    let hours = value.getHours().toString();
    hours = hours.length === 1 ? ('0' + hours) : hours;

    let minutes = value.getMinutes().toString();
    minutes = minutes.length === 1 ? ('0' + minutes) : minutes;

    let seconds = value.getSeconds().toString();
    seconds = seconds.length === 1 ? ('0' + seconds) : seconds;
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
export { DateConverter };
